export const textPopups = {
  // 15232 : "Dal 26 Aprile vi aspettiamo nella nostra nuova sede in via P.Mascagni 2/A a Gatteo a Mare"
};
